import { render, staticRenderFns } from "./SongResults.vue?vue&type=template&id=07af36e8&scoped=true"
import script from "./SongResults.vue?vue&type=script&lang=ts"
export * from "./SongResults.vue?vue&type=script&lang=ts"
import style0 from "./SongResults.vue?vue&type=style&index=0&id=07af36e8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07af36e8",
  null
  
)

export default component.exports